import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import { connect } from 'react-redux';

import localStorage from '../../utils/localStorage';
import ReportTable from './ReportTable';
import { reportTableCall } from './ReportCalls';
import { generateColumn } from './utils/reportutils';

const Reports = (props) => {
  const [state, setState] = useState({
    reportName: '',
    reportJSON: [],
    currentTab: '',
    tabPosition: 'top',
    selectedThemeing: props.selectedThemeing,
    selectedTheme: props.selectedTheme
  });
  const [searchText, setSearchText] = useState('');
  const [language, setLanguage] = useState(localStorage.get('currentLanguage') || 'English');
  const searchInput = useRef(null);

  const params = useParams();
  const location = useLocation();

  const parsedParams =
    Object.keys(params).length && params.report
      ? params
      : props.match
      ? props.match.params
      : {};
      
  const parsedQuery = location && location.search ? location : props.location || {};
const prevReportNameRef = useRef('');

useEffect(() => {
  const reportName = parsedParams.report;
  const reportType = parsedParams.reportType;

  // Don't fetch if reportName hasn't changed
  if (!reportName || reportName === prevReportNameRef.current) return;

  prevReportNameRef.current = reportName; // update previous report name
  fetchReportData(reportName, reportType);
}, [parsedParams.params,parsedParams.report, parsedParams.reportType]);


  // useEffect(() => {
  //   console.log(parsedParams.report,'parsedParams');
    
  //   const reportName = parsedParams.report;
  //   const reportType = parsedParams.reportType;
  //   console.log(reportName,"reportName------",reportType);
    
  //   fetchReportData(reportName, reportType);
  // }, [parsedParams.params,parsedParams.report,parsedParams.reportType]);

  const fetchReportData = async (reportName, reportType) => {
    try {
      const response = await reportTableCall(reportName, reportType);
      const formatted = await adaptTableColumns(response);

      setState(prev => ({
        ...prev,
        reportName,
        reportJSON: formatted,
        currentTab: formatted?.[0]?.TabName || ''
      }));
    } catch (err) {
      console.error('Error loading report:', err);
    }
  };

  const adaptTableColumns = async (reportJSON) => {
    return await Promise.all(
      reportJSON.map(async (item) => {
        const config = item.JSON.tableConfiguration?.style || {};
        const columns = item.JSON.columns;

        item.JSON.columns = await Promise.all(
          columns.map(async (col) => {
            return col.children
              ? {
                ...col,
                children: col.children.map(child =>
                  generateColumn(child, config, searchInput, searchText, setSearchText)
                )
              }
              : generateColumn(col, config, searchInput, searchText, setSearchText);
          })
        );

        return item;
      })
    );
  };

  const onTabChange = (tabKey) => setState(prev => ({ ...prev, currentTab: tabKey }));

  const tabItems = state.reportJSON?.map((tab) => ({
    key: tab.TabName,
    label: tab.TabName,
    children: tab.JSON ? <ReportTable {...tab} /> : null
  }));

  return (
    <div style={{ margin: '5px', padding: '30px' }}>
      {state.reportJSON.length > 1 ? (
        <Tabs
          tabPosition={state.tabPosition}
          items={tabItems}
          onChange={onTabChange}
        />
      ) : (
        state.reportJSON[0] && (
          <ReportTable
            {...{
              ...state.reportJSON[0].JSON,
              ...parsedQuery,
              ...parsedParams,
              reportName: state.reportName,
              childTable: state.reportJSON[0]?.JSON?.childTable || []
            }}
            CurrentLanguage={language}
            onChangeLang={setLanguage}
          />
        )
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedThemeing: state.ThemeReducer.selectedThemeing,
  selectedTheme: state.ThemeReducer.selectedTheme
});

export default connect(mapStateToProps)(Reports);
